import OCGatewayClient from "../client/OCGatewayClient";
import { useInfiniteQuery, useQueryClient } from "@tanstack/react-query";
import { Device } from "../models/Device";
import {
    gatewayRealtimeQueryOptions,
    infiniteQueryHasItem,
    prependInfiniteQueryItem,
    removeInfiniteQueryItem
} from "./gatewayQueryUtils";

let subscribed = false;

export function useDevicesQuery() {
    const queryClient = useQueryClient();

    const query = useInfiniteQuery({
        queryKey: ['getDevices'],
        queryFn: async ({pageParam : beforeCursorId}) : Promise<any> => {
            if (!beforeCursorId) {
                return OCGatewayClient.request('getDevices', {
                    subscribe: true
                }) as Promise<Device[]>;
            }
            else
            {
                return OCGatewayClient.request('getDevices', {
                    beforeCursorId
                }) as Promise<Device[]>;
            }
        },
        ...gatewayRealtimeQueryOptions,
        getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => {
            return lastPage.length ? lastPage[lastPage.length - 1].cursorId : undefined;
        },
        initialPageParam: undefined
    });

    if(!subscribed) {
        OCGatewayClient.socket.on('userDeviceUpdate', (data: any) => {
            queryClient.setQueryData(['getDevices'], (queryData: any) => {
                const matchesUpdate = (device: Device) => device.deviceId === data.body?.deviceId;

                if(data.type === 'create')
                {
                    // The device may already be in the cache: the claiming session
                    // refetches the list on claim success, and a reconnect-triggered
                    // refetch can also have picked it up before the push arrives.
                    if (infiniteQueryHasItem<Device>(queryData, matchesUpdate)) {
                        console.log('userDeviceUpdate (already present)', data);
                        return queryData;
                    }

                    return prependInfiniteQueryItem<Device>(queryData, data.body, 'userDeviceUpdate');
                }

                if(data.type === 'delete')
                {
                    return removeInfiniteQueryItem<Device>(queryData, matchesUpdate, 'userDeviceUpdate');
                }

                console.log('userDeviceUpdate (no match)', data);
                return queryData;
            });
        });

        subscribed = true;
    }

    return query;
}
